export class Geometry {
  coordinates: number[][][][];
  type: string;
}

export class Address {
  fullAddress: string;
  house: number;
  street: string;
  unit?: string;
  postCode: string;
}

export class Assessment {
  buildingValue: number;
  landValue: number;
  taxConsolidation: boolean;
  totalValue: number;
}

export class SolarDetails {
  dailyAverageOptimal: number;
  dailyAverageRoof: number;
  southPercentage: number;
  starRating: number;
}

export class Building {
  heritageRegistry: boolean;
  heritageStatus?: string;
  heritageInventory?: string;
  heritageLegallyProtected?: boolean;
  name: string;
  solarDetails: SolarDetails;
  subtype: string;
  type: string;
  yearBuilt: number;
}

export class LegalPlan {
  fileName: string;
  planNumber: string;
  type: string;
}

export class Drawing {
  drawingNumber: string;
  drawingType: string;
  drawingYear: string;
  fileName: string;
}

export class Documents {
  legalPlans: LegalPlan[];
  sanitaryDrawings: Drawing[];
  stormDrawings: Drawing[];
  waterDrawings: Drawing[];
}

export class Geography {
  area: number;
  elevation: number;
  latitude: number;
  longitude: number;
  streetViewAngle: number;
  streetViewLat: number;
  streetViewLong: number;
}

export class Identification {
  dbLink: string;
  folio: string;
  ltopid: string;
  legalDescription: string;
}

export class Ownership {
  isLeased: boolean;
  isVacant: boolean;
  propertyType: string;
  propertyOwners: PropertyOwner[];
}

export class DPA {
  name: string;
  subtype: string;
}

export class HazardReport {
  author: string;
  date: string;
  fileName: string;
  hazardType: string;
  name: string;
  url: string;
}

export class Zoning {
  zoneClass: string;
  zoning: string;
}

export class SpatialRelations {
  dpAs: DPA[];
  electoralRiding: string;
  mla: string;
  elementarySchool: string;
  firehall: string;
  garbageDays: string[];
  hazardReports: HazardReport[];
  hospital: string;
  hydrant: number;
  library: string;
  neighbourhood: string;
  policeStation: string;
  recreationCentre: string;
  secondarySchool: string;
  zonings: Zoning[];
  snowLoad: string;
  snowPriorities: string[];
  ismpZone: string[];
  transitOrientedArea: string;
}

export class EnergovPermit {
  permitId: string;
  permitNumber: string;
  permitType: string;
  workClass: string;
  status: string;
  issueDate: Date;
  mainParcel: string;
  mainAddress: string;
  hasActiveHolds: string;
  hasParcelHold: string;
  rowVersion: string;
  lastChangedDate: Date;
  dbLink: string;
}

export class EnergovPlan {
  planId: string;
  planNumber: string;
  planType: string;
  workClass: string;
  status: string;
  applyDate: Date;
  mainParcel: string;
  mainAddress: string;
  hasActiveHolds: string;
  hasParcelHold: string;
  rowVersion: string;
  lastChangedDate: Date;
}

export class EnergovCodeCase {
  codeCaseId: string;
  codeCaseNumber: string;
  codeCaseType: string;
  status: string;
  openedDate: Date;
  mainParcel: string;
  mainAddress: string;
  rowVersion: string;
  lastChangedDate: Date;
}

export class EnergovBusLicense {
  licenseId: string;
  licenseNumber: string;
  dBA: string;
  classification: string;
  status: string;
  licenseYear: number;
  mainParcel: string;
  mainAddress: string;
  hasActiveHolds: string;
  hasParcelHold: string;
  rowVersion: string;
  lastChangedDate: Date;
}

export class EnergovInfo {
  energovPermits?: EnergovPermit[];
  energovCodeCases?: EnergovCodeCase[];
  energovBusLicenses?: EnergovBusLicense[];
  energovPlans?: EnergovPlan[];
}

export class Details {
  assessment: Assessment;
  building?: Building;
  documents: Documents;
  geography: Geography;
  identification: Identification;
  ownership: Ownership;
  spatialRelations: SpatialRelations;
}

export class Property {
  addresses: Address[];
  dbLink: string;
  details?: Details;
  ltopid: string;
}

export class PropertyInfo {
  // geometries?: Geometry[];
  properties: Property[];
  propertyCount: number;
}

export interface PropertyOwner {
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  address5: string;
  address6: string;
  country: string;
  name: string;
  ownerType: string;
  postalCode: string;
  primaryClass: string;
  gisLink?: string;
}

export interface PropertyAirSpace {
  dblink: string;
  airspace: string;
}

export interface PropertiesState {
  propertyInfo: PropertyInfo[];
  selectedProperty: string;
  propertiesDBLink: PropertyAirSpace[];
  boundingBox: any;
  geoJson: any;
  energovInfo: EnergovInfo;
}



export const initialPropertiesState: PropertiesState = {
  propertyInfo: [],
  selectedProperty: '',
  propertiesDBLink: [],
  boundingBox: {},
  geoJson: {},
  energovInfo: null
};
